import { supabase } from './supabase';
import type { BackgroundVideo } from './api';

export type NewBackgroundVideo = Omit<
  BackgroundVideo,
  'id' | 'created_at' | 'updated_at'
>;

const TABLE = 'background_videos';

export async function listBackgroundVideos(
  includeInactive = false
): Promise<BackgroundVideo[]> {
  let query = supabase
    .from(TABLE)
    .select('*')
    .order('name', { ascending: true });

  if (!includeInactive) {
    query = query.eq('active', true);
  }

  const { data, error } = await query;

  if (error) throw error;
  return (data as BackgroundVideo[]) || [];
}

export async function createBackgroundVideo(
  input: NewBackgroundVideo
): Promise<BackgroundVideo> {
  const payload = {
    name: input.name,
    file_name: input.file_name,
    preview_image_url: input.preview_image_url ?? '',
    active: input.active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();

  if (error) throw error;
  return data as BackgroundVideo;
}

export async function updateBackgroundVideo(
  id: string,
  input: NewBackgroundVideo
): Promise<BackgroundVideo> {
  const payload = {
    name: input.name,
    file_name: input.file_name,
    preview_image_url: input.preview_image_url ?? '',
    active: input.active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .update(payload)
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as BackgroundVideo;
}

export async function deleteBackgroundVideo(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);

  if (error) throw error;
}
